module.exports = __webpack_public_path__ + "img/img_tab_2.f8b8fe65.png";